module.exports = __webpack_public_path__ + "static/media/about-us_large.f72db23e.jpg";